export const billsCardContents = {
  labels: {
    bills: "Bills",
    pending: "Pending",
    rejected: "Rejected",
    paid: "Paid",
    recentBills: "Recent Bills:"
  },
  buttons: {
    utilizeMoney: "Utilize money",
    seeMore: "See more"
  }
};
